// Angular
import { Injectable } from '@angular/core';
// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
// RxJS
import { map, mergeMap } from 'rxjs/operators';

// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  UserwfdActionToggleLoading,
  UserwfdActionTypes,
  UserwfdPageLoaded,
  UserwfdPageRequested,
  UserwfdPageToggleLoading,
} from '../_actions/userwfd.actions';
// Services
import { UserwfdService } from '../_services/userwfd.service';

@Injectable()
export class UserwfdEffects {
  showPageLoadingDistpatcher = new UserwfdPageToggleLoading({
    isLoading: true,
  });
  hidePageLoadingDistpatcher = new UserwfdPageToggleLoading({
    isLoading: false,
  });

  showActionLoadingDistpatcher = new UserwfdActionToggleLoading({
    isLoading: true,
  });
  hideActionLoadingDistpatcher = new UserwfdActionToggleLoading({
    isLoading: false,
  });

  loadUserwfdPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UserwfdPageRequested>(UserwfdActionTypes.UserwfdPageRequested),
      mergeMap(({ payload }) => {
        this.store.dispatch(this.showPageLoadingDistpatcher);
        const requestToServer = this.ess.findUserwfds(payload.page);
        const lastQuery = of(payload.page);
        return forkJoin(requestToServer, lastQuery);
      }),
      map(response => {
        const result: QueryResultsModel = response[0];
        const lastQuery: QueryParamsModel = response[1];
        return new UserwfdPageLoaded({
          userwfds: result.items,
          totalCount: result.totalCount,
          page: lastQuery,
        });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private ess: UserwfdService,
    private store: Store<AppState>
  ) {}
}
